if (!customElements.get('custom-product-specifications')) {
    customElements.define(
      'custom-product-specifications',
      class CustomProductSpecifications extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
          this.productFormActions = document.querySelector('.main-product-form');
          this.mainProductInfo = document.querySelector('product-info');
          this.product_dimensions = document.querySelector('#collapsible-container-product_dimensions');
          this.product_dimensions_header = this.product_dimensions.querySelector('.collapsible-header');
          this.syncWithMainProductForm();
          this.collapsibleHeaders = this.querySelectorAll('.collapsible-header');
          this.variantMetafields = document.getElementById('variant-metafields');
          this.rawVariantMetafields = JSON.parse(this.variantMetafields.textContent);
          this.variantMetafieldValues = {};
          for (const [variantId, data] of Object.entries(this.rawVariantMetafields)) {
            this.variantMetafieldValues[variantId] = {
              ...data.pdp,
              assembly: {
                assembly_required: data.assembly?.assembly_required || null,
                assembly_manual: data.assembly?.assembly_manual || []
              },
              reference_images: data.reference_images || null
            };
          }
  
          this.collapsibleHeaders.forEach(header => {
            header.addEventListener('click', () => {
              this.toggleCollapsible(header);
            });
          });

          window.addEventListener('DOMContentLoaded', () => {
            if(this.product_dimensions_header) {
              this.toggleCollapsible(this.product_dimensions_header);
            }

            const collapsibleContainers = this.querySelectorAll('.collapsible-container');
            collapsibleContainers.forEach(collapsibleContainer => {
              const noData = collapsibleContainer.querySelector('.no-data');
              if(noData) collapsibleContainer.classList.add('hidden');
            });

            this.checkFirstCollapsibleVisible();
          });
        }

        checkFirstCollapsibleVisible() {
          const collapsiblePaddingTopNone = this.querySelector('.collapsible-header.padding-top-none');
          const collapsibleContainer = this.querySelector('.collapsible-container:not(.hidden)');
          if(collapsiblePaddingTopNone) collapsiblePaddingTopNone.classList.remove('padding-top-none');
          if(collapsibleContainer) collapsibleContainer.querySelector('.collapsible-header').classList.add('padding-top-none');
        }
  
        toggleCollapsible(header) {
          const content = header.nextElementSibling;
          header.classList.toggle('open')
          if (content.style.maxHeight) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + 32 + "px";
          }
        }
  
        syncWithMainProductForm() {
          FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
            const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
            if (!isMainProduct) return;
            const variant = event.data.variant;
            this.updateMetafieldsData(variant);
          });
        }
  
        updateMetafieldsData(variant) {
          const metafieldKeyVariant = ['product_dimensions', 'key_details', 'package_dimensions', 'assembly'];
          const valueMetafields = this.variantMetafieldValues[variant.id];
          for (const key of metafieldKeyVariant) {
            let collapsibleContainer = this.querySelector(`#collapsible-container-${key}`);
            if(!collapsibleContainer) continue;
            let collapsibleOpen = collapsibleContainer.querySelector(`.collapsible-header.open`);
            let contentHTML = collapsibleContainer.querySelector(".collapsible-content");
            if(valueMetafields[key]) {
              let content = this.getContentMetafieldVariantHtml(valueMetafields[key], key);
              if(!content) {
                collapsibleContainer.classList.add('hidden');
                continue;
              };
              contentHTML.innerHTML = content;
              collapsibleContainer.classList.remove('hidden');
              contentHTML.classList.remove('no-data');
            }
            else {
              collapsibleContainer.classList.add('hidden');
            }
            if(collapsibleOpen) {
              const content = collapsibleOpen.nextElementSibling;
              content.style.maxHeight = content.scrollHeight + 32 + "px";
            }
          }
          this.checkFirstCollapsibleVisible();
        }
  
        getContentMetafieldVariantHtml(data, type) {
          let contentHTML = "";
          switch (type) {
            case "product_dimensions":
              data.forEach(item => {
                if(Array.isArray(item.values)) {
                  item.values.forEach(itemChild => {
                    contentHTML += `<div class="collasible-item ${itemChild.name != "Package Quantity" ? 'package-dimension' : ''}">
                        <div class="collasible-item__inner flex justify-between">
                            <h4 class="prd-specification__title">${itemChild.name}:</h4>
                            <span class="prd-specification__value">${itemChild.value}</span>
                        </div>
                    </div>`;
                  });
                }
                else {
                  contentHTML += `<div class="collasible-item">
                      <div class="collasible-item__inner flex justify-between">
                          <h4 class="prd-specification__title">${item.name}:</h4>
                          <span class="prd-specification__value">${item.value}</span>
                      </div>
                  </div>`;
                }
              });
              break;
            case "package_dimensions":
              data.forEach(item => {
                if(Array.isArray(item.values)) {
                  item.values.forEach(itemChild => {
                    contentHTML += `<div class="collasible-item ${itemChild.name != "Package Quantity" ? 'package-dimension' : ''}">
                        <div class="collasible-item__inner flex justify-between">
                            <h4 class="prd-specification__title">${itemChild.name}:</h4>
                            <span class="prd-specification__value">${itemChild.value}</span>
                        </div>
                    </div>`;
                  });
                }
                else {
                  contentHTML += `<div class="collasible-item">
                      <div class="collasible-item__inner flex justify-between">
                          <h4 class="prd-specification__title">${item.name}:</h4>
                          <span class="prd-specification__value">${item.value}</span>
                      </div>
                  </div>`;
                }
              });
              break;
            case "key_details":
              data.forEach(item => {
                contentHTML += `<div class="collasible-item">
                    <div class="collasible-item__inner flex justify-between">
                        <h4 class="prd-specification__title">${item.name}:</h4>
                        <span class="prd-specification__value">${item.value}</span>
                    </div>
                </div>`;
              });
              break;
            case "assembly":
              if(!data.assembly_required && data.assembly_manual.length === 0) {
                break;
              }
  
              if(data.assembly_required) {
                contentHTML += `<div class="collasible-item">
                    <div class="collasible-item__inner flex justify-between">
                        <h4 class="prd-specification__title">Assembly Required:</h4>
                        <span class="prd-specification__value">${data.assembly_required}</span>
                    </div>
                </div>`;
              }
              if(data.assembly_manual.length > 0) {
                let linksHTML = "";
                data.assembly_manual.forEach(item => {
                  linksHTML += `<a download href="${item}" class="prd-specification__link">Download Here</a>`;
                });
                contentHTML += `<div class="collasible-item">
                      <div class="collasible-item__inner flex justify-between">
                          <h4 class="prd-specification__title">Assembly PDF Manual:</h4>
                          <div class="prd-specification__links">
                            ${linksHTML}
                          </div>
                      </div>
                  </div>`;
              }
              break;
            default:
              contentHTML = "";
          }
          return contentHTML;
        }
      }
    );
  }